import { useMemo } from 'react';

export type Platform = 'web' | 'mobile' | 'desktop';

export function usePlatform(): Platform {
  return useMemo(() => {
    const env =
      (typeof import.meta !== 'undefined' &&
        (import.meta as ImportMeta & { env?: Record<string, string> }).env?.VITE_PLATFORM) ||
      'web';
    if (env === 'ios' || env === 'android' || env === 'mobile') return 'mobile';
    if (env === 'desktop' || env === 'electron') return 'desktop';
    if (typeof window !== 'undefined' && (window as Window & { __ELECTRON__?: boolean }).__ELECTRON__) {
      return 'desktop';
    }
    return 'web';
  }, []);
}
